import React, { Component } from 'react';
import { getUser} from '../Actions/UserActions';

import { connect } from 'react-redux';


import NavBar2 from "./NavBar2";
import SiteFoot from "../Components/SiteFoot";

class lawfirm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            width: window.innerWidth,
            password: '',
            error: '',
            lang: navigator.language || navigator.userLanguage
        };
    }
    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

// make sure to remove the listener
// when the component is not mounted anymore
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }
    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };











    render() {


        var lang
        if(this.props.lang==="zh"||this.props.lang==="zh-hk"||this.props.lang==="zh-cn"||this.props.lang==="zh-sg"||this.props.lang==="zh-tw"|| this.props.lang==="zh-HK"||this.props.lang==="zh-CN"||this.props.lang==="zh-SG"||this.props.lang==="zh-TW"){
            lang= "zh"
        }else{
            lang="en"
        }


        return (
<div style={{backgroundColor:"white"}}>



            <div  style={{backgroundColor:"white", width: "100%", display: "flex", top: "0", position:"fixed", left: "0px",
                zIndex: "500",  borderStyle: "solid",  borderColor: "FireBrick", borderWidth: "0px 0px 2px 0px"}}>

                <NavBar2/>


            </div>
            {this.state.width<500 &&<div style={{height: "16vw", position:"relative"}} ></div>}
            {this.state.width>=500 &&<div style={{height: "6vw", position:"relative"}} ></div>}
            <div style={{


                width: "100%", position:"fixed",}} >


                {lang==="en" && <div>
                    <br/>
                    <div style={{fontSize:"10vw", textAlign:"center"}}>Coming Soon</div>

                </div>}

                {lang==="zh" && <div>
                    <br/>
                    <div style={{fontSize:"10vw", textAlign:"center"}}>Coming Soon</div>
                </div>}

            </div>
            <SiteFoot lang={lang}/>

</div>


        );
    }
}

function mapStateToProps(state, ownProps) {
    return { user: state.user, admin: state.admin, lang: state.lang  };
}

export default connect(mapStateToProps, {  getUser })(lawfirm);



// WEBPACK FOOTER //
// ./src/Containers/lawfirm.js